import styled from 'styled-components'
import qs from 'qs'
import { get } from 'lodash'

export default styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  // background-color: #b3b3b3;
  background-color: transparent;
  vertical-align: top;
  object-fit: cover;
  z-index: 1;
  ${props => {
    if ((get(props, 'src') || '').indexOf('?') > -1) {
      const [pathname, search] = props.src.split('?')
      let parsed = qs.parse(search)
      parsed = { ...parsed, width: (parsed.width / 6) < 100 ? 100 : (parsed.width / 6) }

      return `
        background-image: url('${pathname}?${qs.stringify(parsed)}');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `
    }
  }}
  ${props => `
    -webkit-border-radius: ${props.borderRadius || 0};
    -moz-border-radius: ${props.borderRadius || 0};
    border-radius: ${props.borderRadius || 0};
    `}
`

export const AspectRatioImageContainer = styled.div`
  position: relative;
  height: 0;
  `



// WEBPACK FOOTER //
// ./src/components/AspectRatioImage.js